import { theme } from './components/Theme';

export const toRem = pixels => {
  return `${pixels / theme.fontSizeBase}rem`;
};

// Removes the layers of value from the props
// This returns a new changed props
export const cleanProps = props => {
  const objectMap = (obj, fn) =>
    Object.fromEntries(
      Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)])
    );

  return objectMap(props, value => {
    if (value === null) return null;
    if (typeof value === 'object' && 'value' in value) {
      if (value.value === null) return null;
      if (typeof value.value === 'object' && 'value' in value.value) {
        return value.value.value;
      }
      return value.value;
    }
    return value;
  });
};

// Removes the layers of value from the props
// This returns a new changed props
export const cleanDataProps = propArray => {

  let dataObject = {};

  if(!Array.isArray(propArray)) {
    return dataObject;
  }

  propArray.forEach(item => {
    if (item === null) return null;
    if (typeof item === 'object' && 'value' in item) {
      if (item.value === null) return null;
      if (typeof item.value === 'object' && 'value' in item.value) {
        dataObject[item.name] = item.value.value;
      } else {
        dataObject[item.name] = item.value;
      }
    } else {
      dataObject[item.name] = item;
    }
  });

  return dataObject;

};


/**
 *
 * @param {*} possiblyAString
 * @returns
 */
export const convertStringToNumberWithComma = possiblyAString =>
  typeof possiblyAString === 'string'
    ? possiblyAString?.replace(/,/, '.')
    : possiblyAString;

/**
 *
 * @param {object} price price object
 * @param {object} previousPrice previous price object
 * @param {number} fixed number of decimal places
 * @returns {number}
 */
export const getSavedAmount = (price, previousPrice, fixed) => {
  const savedAmount = previousPrice - price;

  return getRoundedAmount(savedAmount, fixed);
};

/**
 *
 * @param {number} amount
 * @param {number} fixed
 * @returns {number}
 */
export const getRoundedAmount = (amount, fixed = 0) => {
  const _amount = convertStringToNumberWithComma(amount);
  return Number(
    Math.round((Number(_amount) + Number.EPSILON) * 100) / 100
  ).toFixed(fixed);
};

/**
 *
 * @param {object} currencyLocale
 * @returns {number}
 */
export const useDecimals = currencyLocale =>
  currencyLocale.code === 'EUR' ? 2 : 0;
